import React, { useMemo } from 'react';
import { PagesForTelemetry } from '../../..';
import { useCategoryFeaturesSection } from '../../CategoryFeaturesSection/CategoryFeaturesSection.controller';
import { StyledShowcaseContainer, styles } from '../../CategoryFeaturesSection/CategoryFeaturesSection.styles';
import { CategoryShowcase } from '../../CategoryShowcase';
import { ProductCatalogSearchQueryOrderBy, useProductCatalogAdsQuery } from '@graphql/generated';
import { useFeatureValue } from '@shared/core/featureFlags';
import { TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { useTranslation } from '@shared/core';

export type CatalogCarouselProps = {
  isMobile: boolean;
  telemetryPageValue: PagesForTelemetry;
  showcaseExploreAllRef?: React.RefObject<HTMLDivElement>;
  sortBy?: ProductCatalogSearchQueryOrderBy;
  placement: 'top' | 'bottom';
  showTitle?: boolean;
};

const CatalogCarousel = (props: CatalogCarouselProps) => {
  const { categoryShowcaseList, selectedCategory, handleBrowseCategoryClick } = useCategoryFeaturesSection(props);
  const isPaidAdsEnabled = useFeatureValue('paidAdsForShopEnabled')?.value === 'on';
  const { data, loading: isBrandPromoLoading } = useProductCatalogAdsQuery({
    skip: !isPaidAdsEnabled,
    batchMode: 'fast',
  });
  const selectedBrandPromo = useMemo(() => {
    return data?.productCatalogAds?.departmentBrandPromos?.find(depBrandPromo => depBrandPromo.department.id === selectedCategory?.id)?.categoryCarousel;
  }, [data?.productCatalogAds?.departmentBrandPromos, selectedCategory?.id]);

  const { t } = useTranslation('catalogRegistry');
  const { exploreMoreTitle } = t('productGrid');
  return (
    <>
      {categoryShowcaseList.length > 1 && !isBrandPromoLoading && (
        <>
          {props?.showTitle && (
            <TextV2
              marginTop={pxToRem(96)}
              paddingX={{ lg1: 10, md3: pxToRem(40), _: 6, xxl: pxToRem(88) }}
              fontWeight={700}
              fontSize={24}
            >
              {exploreMoreTitle()}
            </TextV2>
          )}
          <StyledShowcaseContainer __css={styles.showcaseContainer}>
            <CategoryShowcase
              selectedBrandPromo={selectedBrandPromo}
              categories={categoryShowcaseList}
              key={selectedCategory?.id}
              onBrowseCategoryClick={handleBrowseCategoryClick}
              selectedCategory={selectedCategory}
            />
          </StyledShowcaseContainer>
        </>
      )}
    </>
  );
};

export default CatalogCarousel;
